import { FC } from 'react';

import { Box, Button } from '@bonusly/design-system';

interface StopButtonProps {
	onStopRecording: () => void;
}

export const StopButton: FC<StopButtonProps> = ({ onStopRecording }) => (
	<Box position="absolute" bottom="20px" left="50%" display="flex" alignItems="center" justifyContent="center">
		<Button
			width="52px"
			height="52px"
			ml="-26px"
			borderRadius="full"
			border="2px"
			borderColor="white"
			onClick={onStopRecording}
			_hover={{ bg: 'transparent' }}
			bg="transparent"
		>
			<Box position="absolute" width="16px" height="16px" bg="red.500" />
		</Button>
	</Box>
);
